// Equity-deal detection.
// The backend's "user_deposit" branch defines equity deals as deal type 2.
// Some deal payloads also carry the type via metadata.overview.salesType.type.
// useListV2 normalizes that path to a top-level `saleType` string.
// We accept any of these as proof of equity until the payload is canonicalised.

const matchesEquityString = (val: unknown): boolean =>
  typeof val === 'string' && val.toLowerCase() === 'equity'

export const isEquityDeal = (deal: any): boolean => {
  if (!deal) return false
  if (deal.type === 2) return true
  if (matchesEquityString(deal.saleType)) return true
  return matchesEquityString(deal?.metadata?.overview?.salesType?.type)
}
